import { message, Modal } from "antd";
import React, { useEffect, useState } from "react";
import { useHistory } from "react-router-dom/cjs/react-router-dom.min";
import { fetchCalibrationApi } from "../../../api/fetchCalibration";
import AKCal from "../../../assets/icon/calibration/AKCal.svg";
import allCal from "../../../assets/icon/calibration/allCal.svg";
import MPCal from "../../../assets/icon/calibration/MPCal.svg";
import PECal from "../../../assets/icon/calibration/PECal.png";
import PPCal from "../../../assets/icon/calibration/PPCal.svg";
import RACal from "../../../assets/icon/calibration/RACal.svg";
import listen from "../../../assets/icon/listen.png";
import readIcon2 from "../../../assets/icon/readIcon2.svg";
import speak from "../../../assets/icon/speak.svg";
import submitIcon from "../../../assets/icon/submitIcon.svg";
import tapIcon from "../../../assets/icon/tapIcon.svg";
import typingIcon from "../../../assets/icon/typingIcon.svg";
import { getFullScreen } from "../../../helper/fullscreen";
import {
  allAKCalId,
  allCalId,
  allMPCalId,
  allPECalId,
  allPPCalId,
  allRACalId,
} from "../../../helper/constant/calibrationSectionId";
import { cancelFullScreen } from "../../../helper/fullscreen";
import { AnswerContext } from "../../../store/answerStore";
import { HelperContext } from "../../../store/helperStore";
import { LaunchTestContext } from "../../../store/launchTestStore";
import { RecorderContext } from "../../../store/recorderStore";
import { setLocalStorage } from "../../../helper/localStorage";

const instIcon = [
  { img: listen, title: "Listen" },
  { img: speak, title: "Speak" },
  { img: readIcon2, title: "Read" },
  { img: typingIcon, title: "Type" },
  { img: tapIcon, title: "Tap" },
  { img: submitIcon, title: "Submit" },
  // { img: hearRead, title: "" },
];

const instMessage = [
  // all instruction
  ["This is a mini-version of the Amaze MAPPR test battery."],
  //Memory Processes
  [
    "This is a mini-version of the Amaze Memory Processes test battery.",
    "It tests your ability to take in information, store it, and recall it later.",
  ],
  // Acquired Knowledge
  [
    "This is a mini-version of the Amaze Acquired Knowledge test battery.",
    "It tests your knowledge obtained from environment around us.",
  ],

  //Processing Efficiency
  [
    "This is a mini-version of the Amaze Processing Efficiency test battery.",
    "It tests your ability to focus one's attention and apply effort to a timed task.",
  ],

  //Perceptual Processes
  [
    "This is a mini-version of the Amaze Perceptual Processes test battery.",
    "It tests your ability to organize, interpret and respond to a variety of stimuli.",
  ],

  // Reasoning Ability
  [
    "This is a mini-version of the Amaze Reasoning Ability test battery.",
    "It tests your ability to identify, evaluate and make a decision while solving a problem.",
  ],
];

const CalibrationSec = [
  {
    img: allCal,
    title: "MAPPR Mini",
    testId: "190425225021",
    bgColor: "#fff",
  },
  {
    img: MPCal,
    title: "Memory Processes",
    testId: "190425225056",
    bgColor: "#E8FDEA",
  },
  {
    img: AKCal,
    title: "Acquired Knowledge",
    testId: "190425225055",
    bgColor: "#F3DFFC",
  },
  {
    img: PECal,
    title: "Processing Efficiency",
    testId: "190425225058",
    bgColor: "#FFDDDD",
  },
  {
    img: PPCal,
    title: "Perceptual Processes",
    testId: "190425225057",
    bgColor: "#FFF1CD",
  },
  {
    img: RACal,
    title: "Reasoning Ability",
    testId: "190425225059",
    bgColor: "#E9EDFE",
  },
];

export default function Calibration() {
  setLocalStorage("isScreenReloaded", false);

  useEffect(() => {
    const getAudioPermission = () => {
      if (navigator.mediaDevices) {
        navigator.mediaDevices.getUserMedia(
          { audio: true },
          function (stream) {
            stream.getTracks().forEach((x) => x.stop());
          },
          (err) => console.log(err)
        );
      } else {
        message.error("Your browser does not support audio recording");
      }
    };
    getAudioPermission();
  }, []);

  const history = useHistory();

  const { helperC, dispatchHelper } = HelperContext();
  const { recorderC, dispatchRecorder } = RecorderContext();
  const { launchTestC, dispatchLaunchTest } = LaunchTestContext();
  const { answerC, dispatchAnswer } = AnswerContext();

  const [instVisible, setInstVisible] = useState();
  const [selectedTestId, setSelectedTestId] = useState();

  const isAllCal = selectedTestId === allCalId;
  const isMPCal = selectedTestId === allMPCalId;
  const isAKCal = selectedTestId === allAKCalId;
  const isPECal = selectedTestId === allPECalId;
  const isPPCal = selectedTestId === allPPCalId;
  const isRACal = selectedTestId === allRACalId;

  useEffect(() => {
    dispatchLaunchTest({ type: "RESET" });
    dispatchAnswer({ type: "RESET_ANSWER" });
    dispatchHelper({ type: "TEST_TYPE", payload: "" });
    dispatchHelper({ type: "RUNNING_QUES_ID", payload: "" });
    dispatchHelper({ type: "FN_QUES_ID", payload: "11862" });
    dispatchHelper({ type: "RESET_AUDIO_STAT" });
    dispatchHelper({ type: "OFF_HEIGHT", payload: 0 });
    dispatchRecorder({ type: "RESET_STAT" });

    dispatchHelper({
      type: "FACE_DATA",
      payload: false,
    });
    cancelFullScreen();
  }, []);

  const handleStartCalibration = () => {
    fetchCalibrationApi(selectedTestId, dispatchLaunchTest, dispatchHelper);
    dispatchHelper({ type: "TEST_TYPE", payload: "CALIBRATION" });
    history.push({
      pathname: "/calibration/test",
      state: { routeFrom: "calibration" },
    });
    getFullScreen();
  };

  const handleTestSec = (testId) => {
    setInstVisible(true);
    setSelectedTestId(testId);
  };

  return (
    <>
      <div className="calibration-test">
        <h1 className="">Calibration Test</h1>
        <div className="all-calibrations">
          {CalibrationSec.map((testSec) => (
            <div
              className="calibration-inst-blk"
              style={{ background: testSec.bgColor }}
              onClick={() => handleTestSec(testSec.testId)}
            >
              <div className="calibration-inst-img">
                {testSec.title === "Processing Efficiency" ? (
                  <img
                    src={testSec.img}
                    style={{ width: "142px", height: "138px" }}
                    alt=""
                  />
                ) : (
                  <img src={testSec.img} alt="" />
                )}
              </div>
              <div className="calibration-start-btn">
                <span className="">{testSec.title}</span>
              </div>
            </div>
          ))}
        </div>
      </div>
      <Modal
        style={{ top: 20, maxWidth: "1082px" }}
        width="98%"
        visible={instVisible}
        className="sml-modal dash-inst calibration"
        onCancel={() => setInstVisible(false)}
        footer={
          <div className="sml-footer">
            <button className="custom-btn" onClick={handleStartCalibration}>
              Let's Start
            </button>
          </div>
        }
      >
        <>
          <div className="test-instruction-blk inst">
            <h1 className="test-instruction-title">How to take this Test</h1>
            <>
              <div className="instructions">
                <div className="instruction-do">
                  <h3>
                    <ul>
                      {isAllCal && instMessage[0].map((msg) => <li>{msg}</li>)}
                      {isMPCal && instMessage[1].map((msg) => <li>{msg}</li>)}
                      {isAKCal && instMessage[2].map((msg) => <li>{msg}</li>)}
                      {isPECal && instMessage[3].map((msg) => <li>{msg}</li>)}
                      {isPPCal && instMessage[4].map((msg) => <li>{msg}</li>)}
                      {isRACal && instMessage[5].map((msg) => <li>{msg}</li>)}
                      <li>
                        You can experience each test (a short version with fewer
                        questions) by taking the calibration test.
                      </li>
                      <li>
                        It will help you get familiar with the actual test
                        items, actions needed and instructions to remember.
                      </li>
                      <li>
                        The calibration test is a scored test so do make sure
                        that you attempt it to the best of your ability.
                      </li>
                      <li>
                        You can provide your feedback on any test items or
                        navigation issues to the assessor or write in to
                        <a href="mailto:amazecare@mymemorymentor.com">
                          {" "}
                          amazecare@mymemorymentor.com
                        </a>
                      </li>
                    </ul>
                    <p style={{ textAlign: "center" }}>All the best.</p>
                  </h3>
                </div>
              </div>
              <div className="test-instruction-contents">
                {instIcon.map((insData, index) => (
                  <div key={index} className="test-instruction-content">
                    <div className="test-instruction-img">
                      <img src={insData.img} alt="" />
                    </div>
                    <p>{insData.title}</p>
                  </div>
                ))}
              </div>
            </>
          </div>
        </>
      </Modal>
    </>
  );
}
